import { supportedMeasurementSystemCodes } from "@/models/measurementSystem"
import type { SupportedMeasurementSystemCode } from "@/models/measurementSystem"

export const getDefaultMeasurementSystemCode = (
  locale: string
): SupportedMeasurementSystemCode => {
  if (locale === "en-US") {
    return "USCS"
  }

  return "SI"
}

export const isSupportedMeasurementSystemCode = (
  measurementSystemCode: SupportedMeasurementSystemCode
): boolean => {
  return supportedMeasurementSystemCodes.includes(measurementSystemCode)
}
